import task from './task'
import taskForm from './task-form'

export default {
    task,
    taskForm
}



// WEBPACK FOOTER //
// ./src/store/index.js